export default "/site/aidive/js/react/dist/images/olympiacos-login-icon.9576e320.png";